'use client';

import { toast } from '@/lib/toast';

export default function DebugPage() {
  return (
    <div className="min-h-screen p-8 bg-gray-50">
      <h1 className="text-2xl font-bold mb-4">Debug Info</h1>
      
      <div className="bg-white p-4 rounded shadow space-y-2">
        <div>
          <strong>API URL (from env):</strong>
          <pre className="bg-gray-100 p-2 mt-1 rounded text-sm">
            {process.env.NEXT_PUBLIC_API_URL || 'Not set'}
          </pre>
        </div>
        
        <div>
          <strong>API URL (from lib):</strong>
          <button
            onClick={async () => {
              const { API_URL } = await import('@/lib/api');
              toast.info(`API_URL: ${API_URL}`);
            }}
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
          >
            Click to check
          </button>
        </div>
        
        <div>
          <strong>Window location:</strong>
          <pre className="bg-gray-100 p-2 mt-1 rounded text-sm">
            {typeof window !== 'undefined' ? window.location.href : 'SSR'}
          </pre>
        </div>
      </div>
    </div>
  );
}
